export default __webpack_public_path__ + "static/media/form.a6c35031.svg";